export default __webpack_public_path__ + "static/media/kit_image3.a3248c7a.png";